import type { IUiIncentiveDataProviderV3 } from '@amply-app/sdk/dist/esm/types/contracts/UiIncentiveDataProviderV3';

export const filterRewardData = (
  details?: IUiIncentiveDataProviderV3.RewardInfoStructOutput[],
) => details?.filter((detail) => Number(detail[2])) ?? [];
